import React, { useState } from "react";

import { useAppDispatch, useAppSelector } from "../../store/hooks";

import StakeNumberMultiplier from "./StakeNumberMultiplier";
import SpecialBettings from "./SpecialBettings";
import { getStakeColorAndClass } from "../../utils/NumberDetails";
import { isSpecialBetting } from "../../utils";
import {
  addAllMultipliers,
  removeAllMultipliers,
} from "../../store/picks/userPick-slice";
import store from "../../store/store";
import ModalMessage from "../Common/ModalMessage/ModalMessage";
import { playAudioEffect } from "../../store/audio-slice";
import { AudioEnum } from "../../enums";

interface Props {
  value: string;
  stakes: number[];
}

const StakeNumber: React.FC<Props> = ({ value, stakes }) => {
  const pickedStakes = useAppSelector((state) => state.picks.pickedStakes);
  const [infoModalMessage, setInfoModalMessage] = useState("");
  const dispatch = useAppDispatch();

  const checkNumberOfSelectedMultipliers = (): void => {
    const stakeIndex = pickedStakes.findIndex((stake) => stake.value === value);

    if (
      stakeIndex < 0 ||
      pickedStakes[stakeIndex].valueMultipliers.length < 4
    ) {
      const stakesSum = stakes.reduce((a: number, b: number) => a + b, 0);
      let existingStakesSum = 0;
      if (stakeIndex >= 0) {
        existingStakesSum = pickedStakes[stakeIndex].valueMultipliers.reduce(
          (a: number, b: number) => a + b,
          0
        );
      }
      if (
        stakesSum -
          existingStakesSum +
          store.getState().picks.currentStakeAmount >
        store.getState().config.maxLocationStake / 100
      ) {
        setInfoModalMessage("message.maxStakeReached");
      } else {
        dispatch(playAudioEffect(AudioEnum.EFFECT_FULL_STAKE));
        dispatch(addAllMultipliers({ value, stakes, stakesSum }));
      }
    } else {
      dispatch(playAudioEffect(AudioEnum.EFFECT_DELETE));
      dispatch(removeAllMultipliers(value));
    }
  };

  return (
    <>
      <div className="single_number">
        <StakeNumberMultiplier value={value} valueMultiplier={stakes[0]} />
        <StakeNumberMultiplier value={value} valueMultiplier={stakes[1]} />
        <StakeNumberMultiplier value={value} valueMultiplier={stakes[2]} />
        <StakeNumberMultiplier value={value} valueMultiplier={stakes[3]} />

        <button
          type="button"
          className={`main_num ${getStakeColorAndClass(value)}`}
          onClick={checkNumberOfSelectedMultipliers}
        >
          {isSpecialBetting(value) ? <SpecialBettings value={value} /> : value}
        </button>
      </div>

      {infoModalMessage !== "" && (
        <ModalMessage
          message={infoModalMessage}
          onApprove={() => setInfoModalMessage("")}
        />
      )}
    </>
  );
};

export default StakeNumber;
